<template>
  <div class="animate-pulse bg-white rounded-2xl w-full flex flex-col justify-between p-4 my-4"
    v-if="missingSIN">
    <div class="flex justify-between">
      <div class="flex">
        <div class="flex items-start w-8 mr-1">
          <img class="w-full" :src="'/img/popup/exclamation_grey' + '.svg'" alt="strategy" />
        </div>
        <div>
          <p class="text-left text-grey-2 text-sm font-semibold mb-2">
            {{ $t('settings.personal_details.add_sin.title') }}
          </p>
          <p class="text-left text-grey-2 text-sm text-opacity-50">
            <slot name="content">{{$t('settings.personal_details.add_sin.content')}}</slot>
          </p>
        </div>
      </div>
    </div>
    <div @click="addSin" class="orange-link text-right text-13">{{
      $t('settings.personal_details.add_sin.btn')
    }}</div>
  </div>  
</template>

<script>
import { useStore } from 'vuex'

export default {
  props: {
    missingSIN: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore()

    const addSin = () => {
      const popup = {
        side: false,
        component: 'AddSin'
      }
      store.dispatch('setPopup', popup)
    }

    return { addSin  }
  }
}
</script>
